<template>
  <div class="sharebtn">
    <a-button icon="unordered-list" style="margin-right: 10px;" @click=" visibleShow('share'), init()">反馈列表</a-button>
    <drag-modal title="反馈列表" width="784px" :visible="$store.state.dislog.share" @cancel=" close()" @open="handleOpen">
      <div class="table">
        <table>
          <thead>
            <td width="35%">接收人</td>
            <td width="35%">反馈人</td>
            <td width="30%">反馈日期</td>
          </thead>
          <tbody>
            <tr v-for="i in list">
              <td>{{ i.target_user ? i.target_user.uname : '/' }}</td>
              <td>{{ i.user ? i.user.uname : '/' }}</td>
              <td>{{ i.create_time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pages" v-if="count > 10">
        <a-pagination v-model="page" show-quick-jumper :total="count" show-less-items :pageSize='10' @change='init' />
      </div>
    </drag-modal>
  </div>
</template>
<script>
import { shareHis } from '@/server/debtor'
export default {
  data() {
    return {
      list: [],
      visible: false,
      page: 1,
      count: 0
    }
  },
  watch: {
    // // 监听弹窗显隐状态
    // '$store.state.dislog.share'(val) {
    //   // 弹窗打开时执行初始化
    //   if (val) {
    //     this.page = 1 // 打开弹窗重置页码为第一页
    //     this.init()
    //   }
    // }
  },
  methods: {
    visibleShow(name) {
      this.$store.dispatch("openkey", { key: name, by: true })
    },
    handleOpen() {
      this.page = 1
      this.init()
    },
    close() {
      this.page = 1;
      this.$store.dispatch('openkey', { key: 'share', by: false })
    },

    init() {
      shareHis({ cause_id: this.$store.state.cause.id, limit: 10, page: this.page }).then(e => {
        this.list = e.list
        this.count = e.count
      })
    }
  }
}
</script>